import { DefaultStatesEnum } from '@models/common';
import { FormFieldModel } from '@models/module/fields/main';
import { NotifyEmailsAndRolesModel } from '@module-instance/dynamic-module/common/dm.model';

export type ActivityDetailsModel = {
  entityInstanceId: number;
  createdOn: string;
  userId: number;
  user: string;
  userEmail: string;
  roleName: string;
  roleAbbr: string;
  stateId?: number;
  state: string;
  stateType: number;
  stateTypeId: DefaultStatesEnum;
  stateColor: string;
  stateTextColor: string;
  nextStateId?: number;
  nextState: string;
  nextStateType: number;
  nextStateTypeId: DefaultStatesEnum;
  nextStateColor: string;
  nextStateTextColor: string;
  screenId: number;
  actionId: number;
  transitionId: number;
  transitionName: string;
  actionInstanceId: number;
  isDraftState: boolean;
  sentToUsers: UserRolesModel[];
  notifiedUsers: UserRolesModel[];
  roleToExcludeIds: number[];
  canExclude: boolean;
  canViewExcludedUsers: boolean;
  canUndoLastAction: boolean;
  rollbackToDraft: boolean;
  hasFields: boolean;
  message: string;
  fields: FormFieldModel[];
  preferredFields: PreferredField[];
  type: number;
  /** email to  */
  tos: EmailTo[];
  /** email cc */
  ccs: string[];
  hideRoutedTo: boolean;
};

export type PreferredField = {
  isUsed: boolean;
  otherId: number;
  key: number;
  value: string;
  fieldIds: number[];
};

export type EmailTo = {
  email: string;
  firstName: string;
  id: number;
  isContact: boolean;
  lastName: string;
};

export type ActivityRequestParams = {
  moduleId: number;
  entityInstanceId: number;
  actionInstanceId: number;
  contractId?: number;
  noFields?: boolean;
  notifyUsers?: NotifyEmailsAndRolesModel;
};

export type UserRolesModel = {
  user: string;
  roleAbbrs: string[];
};
